<template>
  <div class="entry-preview">
    <div
      class="entry-preview__buton-close"
      @click="close"
    >
      <base-icon icon="cancel" />
    </div>
    <div
      ref="container"
      class="preview__container"
    >
      <div
        class="preview__wrapper"
        :style="{
          width: '100%',
          'max-width': `${iframe.innerWidth / iframeZoom}px`,
          height: `${iframe.innerHeight / iframeZoom}px`
        }"
      >
        <iframe
          class="preview__iframe"
          :src="previewUrl"
          scrolling="no"
          frameborder="0"
          :style="{
            width: `${iframe.innerWidth * iframeZoom}px`,
            height: `${iframe.innerHeight * iframeZoom}px`,
            transform: `scale(${iframeScale})`,
            zoom: iframeScale,
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EntryPreview',
  data() {
    return {
      iframeScale: 1,
      iframeZoom: 1,
      iframe: {
        innerWidth: 0,
        innerHeight: 0,
      },
      previousScrollTop: 0,
    };
  },
  computed: {
    previewUrl() {
      return `${this.apiRoot()}/render_edit/${this.$route.params.id}/preview`;
    },
  },
  mounted() {
    /** Receive iframe message
     * https://github.com/hello-seer/stylelab-backend/blob/c6842b021d33fc687800c0d2f5937347eeeb5294/stylelab/templates/pages/render_edit.html#L241
     * */
    window.addEventListener('message', this.receiveMessage);

    /** We are listening resize - this solves responsive and resizing the browser */
    this.$nextTick(() => {
      this.onResize();
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    // Remove the events created on Mount so we don't have ghost events
    window.removeEventListener('message', this.receiveMessage);
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onResize() {
      console.log('On resize');
      /** This was our first approach
       * It didn't work because the right line was deleted
       */
      // const scale = this.$refs.container.scrollWidth / this.iframe.innerWidth;
      // const zoom = this.iframe.innerWidth / this.$refs.container.scrollWidth;

      const deltaWidth = 1000; // This is an arbitrary number relative to edit width (900px)
      const scale = this.$refs.container.scrollWidth / deltaWidth;
      const zoom = deltaWidth / this.$refs.container.scrollWidth;

      // We are scaling down only
      this.iframeScale = scale > 1 ? 1 : scale;
      this.iframeZoom = zoom < 1 ? 1 : zoom;
    },
    receiveMessage(message) {
      // Prevent receive message
      if (message.origin !== this.apiRoot()) {
        return;
      }
      if (message.data.modal === 'open') {
        this.previousScrollTop = this.$refs.container.scrollTop;
        this.$refs.container.scrollTop = ((this.iframe.innerHeight * this.iframeScale) / 2)
         - (window.innerHeight / 2) + 32;
        return;
      }
      if (message.data.modal === 'close') {
        this.$refs.container.scrollTop = this.previousScrollTop;
        return;
      }
      this.iframe = message.data;
      this.onResize();
    },
    close() {
      // Not sure why this timeout is here, but I kept it from the old code
      // daviv: Me neither.
      setTimeout(() => {
        this.$router.back();
      }, 400);
    },
  },
};
</script>

<style lang="scss" scoped>
.entry-preview {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  background-color: #222;
  padding: 1rem;

  &__buton-close {
    position: fixed;
    top: 1rem;
    right: 1rem;
    width: 80px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
    z-index: 9;
  }
}
.preview {
  &__container {
    background-color: white;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    justify-content: center;
    padding: 1rem;
  }
  &__iframe {
    // These are overwritten
    width: 1920px; // Initial width
    zoom: 0.5;
    transform: scale(0.5);
    transform-origin: 0 0;
  }

  &__wrapper{
    width: 800px; // This is overwritten by iframe.innerWidth
    height: 2080px; // This is overwritten by iframe.innerHeight
    padding: 0;
    overflow: hidden;
  }
}
</style>
